import { Component, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import * as fromState from '@tv3/store/state'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { selectAllRentals } from '@tokeet-frontend/tv3-platform'
import { FormBuilder, Validators } from '@angular/forms'
import { AuthService } from '@tv3/services/auth.service'
import { startWith } from 'rxjs/operators'
import { Toaster } from '@tokeet-frontend/tv3-platform'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { environment } from '@tv3/environments/environment'

@Component({
  selector: 'app-review-widget',
  templateUrl: './review-widget.component.html',
  styleUrls: ['./review-widget.component.scss'],
})
export class ReviewWidgetComponent implements OnInit {
  widgetCode = ''
  trustedWidgetCode: SafeHtml

  rentals$ = this.store.pipe(select(selectAllRentals))
  borderRadiusOpts = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  form = this.fb.group({
    rental: [undefined],
    source: [undefined],
    color: ['#fff', [Validators.required]],
    backgroundColor: ['#127add', [Validators.required]],
    borderColor: ['#c1c1c1', [Validators.required]],
    borderWidth: [0, [Validators.required]],
    borderRadius: [4, [Validators.required]],
  })

  constructor(
    private store: Store<fromState.State>,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private toast: Toaster,
    private auth: AuthService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.form.valueChanges.pipe(startWith(this.form.getRawValue())).subscribe((config) => {
      this.buildCode(config)
    })
  }

  buildCode(config: any) {
    let source = (config.source || '').trim()
    source = `${source} widget`.trim()
    if (!config.rental || !source) {
      return
    }
    this.widgetCode = `<a class="tokeet-review-widget" href="https://www.tokeet.com"
    data-rental-account="${this.auth.user.account}"
    data-rental-id="${config.rental}"
    data-name="${source}"
    data-color="${config.color}"
    data-background-color="${config.backgroundColor}"
    data-border-width="${config.borderWidth}px"
    data-border-color="${config.borderColor}"
    data-border-radius="${config.borderRadius}px"
    data-environment="${environment.environment === 'production' ? 'prod' : 'dev'}"
    ></a>
    <script src="https://widgets.tokeet.com/setup.min.js"></script>`

    this.trustedWidgetCode = this.sanitizer.bypassSecurityTrustHtml(this.widgetCode)
  }

  onCopied() {
    this.amplitudeService.logEvent('widget-review-copied')
  }

  onColorSelected(key: string, color: string) {
    this.form.patchValue({ [key]: color })
  }
}
